import { FC, useState } from 'react';
import {
  Typography, Row, Layout, message,
} from 'taxaroo-ui';

import { ApolloError } from '@apollo/client';
import { TaxarooAiMessageType } from '~src/graphql';
import CheckMark from 'src/assets/icons/checkmark.svg';
import { useCreateAiAgentMessageMutation } from '~src/graphql/mutations/messaging';
import { GetAiAgentMessagesDocument } from '~src/graphql/queries/messaging';
import SettingsHeader from '../SettingsHeader';
import { AiAssistantPlanType } from '../../AIAssistant';
import * as styles from '../../AIAssistant/styles.module.css';
import AddonsModalContent from '../../AIAssistant/AddonsModalContent';

const { Paragraph, Text } = Typography;

export const chatOnlyCardContent = (
  <>
    <Row className={styles.modalCardTitle}>Chat only plan</Row>
    <Row style={{ fontSize: '14px' }}>Basic plan but only chat available</Row>

    <Row className={styles.modalCardFeatures}>
      <Row className={styles.modalCardFeaturesLine} align="middle">
        <CheckMark className={styles.modalCardFeaturesBasicCheck} />
        Available from your firm dashboard
      </Row>
    </Row>
  </>
);

const Ai: FC = () => {
  const [plan, setPlan] = useState<AiAssistantPlanType>();

  const [createAiAgentMessage] = useCreateAiAgentMessageMutation({
    refetchQueries: [GetAiAgentMessagesDocument],
    awaitRefetchQueries: true,
    onError: (err: ApolloError) => message.error(err.message),
  });

  const subscriptionCreated = async (newPlan: AiAssistantPlanType) => {
    message.success(`Subscription created for ${newPlan} plan`);

    await createAiAgentMessage({
      variables: {
        createAiAgentMessageInput: {
          type: TaxarooAiMessageType.System,
          text: `Welcome back! '${newPlan}' plan unlocked`,
        },
      },
    });

    // reload the page, todo: fix this
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  return (
    <Layout style={{ backgroundColor: 'white' }}>
      <SettingsHeader
        title="AI Settings"
        tooltipTitle="AI Settings"
        tooltipContent={(
          <Paragraph>
            <Text>Customize your AI settings</Text>
          </Paragraph>
        )}
      />
      <div style={{ paddingTop: '20px', marginBottom: '125px' }}>
        <Row>
          <AddonsModalContent
            subscriptionCreated={() => subscriptionCreated(plan)}
            subscriptionCancelled={() => {
              message.success('Subscription cancelled');
            }}
            plan={plan}
            setPlan={setPlan}
          />
        </Row>
      </div>
    </Layout>
  );
};

export default Ai;
